import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecordToolbarComponent } from './record-toolbar.component';
import { MaterialModule } from '@app/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { ClientprojectPickerModule } from '../clientproject-picker/clientproject-picker.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
// import { StaticDTPickerModule } from '../static-dtpicker/static-dtpicker.module';
import { StaticDatePickerModule } from '../static-datepicker/static-dtpicker.module';
import { RecordToolbarService } from './record-toolbar.service';
import { DatepickerMenuModule } from '../menus/datepicker-menu/datepicker-menu.module';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { ClientProjectPickerDialogModule } from '../dialogs/client-project-picker-dialog/client-project-picker-dialog.module';
import { TagPickerDialogModule } from '../dialogs/tag-picker-dialog/tag-picker-dialog.module';
import { TimeInputModule } from '../time-input/time-input.module';
import { DateFnsModule } from 'ngx-date-fns';
import { EntityRefPipesModule } from '@app/_pipes/entity-ref-pipes/entity-ref-pipes.module';
import { RecordToolbarCounterComponent } from './record-toolbar-counter/record-toolbar-counter.component';
import { ParseFeedDescriptionModule } from '@app/pages/feed-page/pipes/parse-feed-description.module';
import { FabricFileIconModule } from '@app/modules/fabric/fabric-file-icon/fabric-file-icon.module';
import { FabricBaseIconModule } from '@app/modules/fabric/fabric-base-icon/fabric-base-icon.module';
import { TimeRangeControlModule } from '@app/components/time-range-control/time-range-control.module';
import { A11yModule } from '@angular/cdk/a11y';

@NgModule({
  declarations: [RecordToolbarComponent, RecordToolbarCounterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MaterialModule,
    TranslateModule,
    ClientprojectPickerModule,
    NgScrollbarModule,
    StaticDatePickerModule,
    SatPopoverModule,
    DatepickerMenuModule,
    ClientProjectPickerDialogModule,
    TagPickerDialogModule,
    DateFnsModule,
    EntityRefPipesModule,
    TimeInputModule,
    ParseFeedDescriptionModule,
    FabricFileIconModule,
    FabricBaseIconModule,
    TimeRangeControlModule,
    A11yModule,
  ],
  exports: [RecordToolbarComponent],
})
export class RecordToolbarModule {
  /**
   * allows saving state without refetching on page load
   */
  static forRoot(): ModuleWithProviders<RecordToolbarModule> {
    return {
      ngModule: RecordToolbarModule,
      providers: [RecordToolbarService],
    };
  }
}
